var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "372px",
    height: "371px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.964
    },
    fill: "#d1e2e8",
    d: "M 228.5,20.5 C 229.497,20.4701 230.164,20.9701 230.5,22C 237.309,40.451 243.976,58.951 250.5,77.5C 222.216,155.217 178.883,223.05 120.5,281C 112.312,288.022 103.979,294.856 95.5,301.5C 95.1667,301.333 94.8333,301.167 94.5,301C 120.39,263.408 143.89,224.241 165,183.5C 169.994,172.185 173.994,160.518 177,148.5C 183.284,124.03 188.618,99.3633 193,74.5C 205.056,56.6176 216.889,38.6176 228.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#69b330",
    d: "M 159.5,77.5 C 166.833,77.5 174.167,77.5 181.5,77.5C 174.492,121.2 162.659,163.533 146,204.5C 140.93,216.317 134.597,227.317 127,237.5C 137.501,184.161 148.335,130.827 159.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95
    },
    fill: "#d1e2e8",
    d: "M 253.5,120.5 C 255.197,122.305 256.03,124.639 256,127.5C 258.331,147.473 259.998,167.473 261,187.5C 217.886,236.973 169.052,279.473 114.5,315C 100.662,323.087 86.6616,330.92 72.5,338.5C 71.2888,337.726 71.2888,336.893 72.5,336C 112.267,302.233 149.434,265.733 184,226.5C 209.923,192.991 233.09,157.658 253.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.963
    },
    fill: "#69b330",
    d: "M 262.5,209.5 C 264.045,210.23 264.878,211.563 265,213.5C 267.501,238.508 270.001,263.508 272.5,288.5C 238.498,288.667 204.498,288.5 170.5,288C 199.124,265.044 227.458,241.711 255.5,218C 258.447,215.564 260.78,212.731 262.5,209.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.41f3e0bfb42d52eb6a1e69756d614db8.svg";
export { ForwardRef as ReactComponent };